/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "items": {
        "nested": {
          "drafts": {
            "nested": {
              "enums": {
                "nested": {
                  "DraftStatus": {
                    "values": {
                      "DRAFT_STATUS_DO_NOT_USE": 0,
                      "DRAFT_STATUS_PENDING": 1,
                      "DRAFT_STATUS_SCHEDULED": 2,
                      "DRAFT_STATUS_PUBLISHED": 3,
                      "DRAFT_STATUS_FAILED": 4,
                      "DRAFT_STATUS_ABANDONED": 5,
                      "DRAFT_STATUS_PUBLISHING": 6,
                      "DRAFT_STATUS_UPDATING": 7
                    }
                  },
                  "UpdateDraftMode": {
                    "values": {
                      "UPDATE_DRAFT_MODE_DO_NOT_USE": 0,
                      "UPDATE_DRAFT_MODE_ADD": 1,
                      "UPDATE_DRAFT_MODE_REPLACE": 2
                    }
                  },
                  "DraftOperation": {
                    "values": {
                      "DRAFT_OPERATION_DO_NOT_USE": 0,
                      "DRAFT_OPERATION_UPSERT": 1,
                      "DRAFT_OPERATION_DELETE": 2
                    }
                  },
                  "DraftType": {
                    "values": {
                      "DRAFT_TYPE_DO_NOT_USE": 0,
                      "DRAFT_TYPE_GENERAL": 1,
                      "DRAFT_TYPE_PRICE": 2,
                      "DRAFT_TYPE_ONLINE_SALE_PRICE": 3
                    }
                  },
                  "RescheduleAction": {
                    "values": {
                      "RESCHEDULE_ACTION_DO_NOT_USE": 0,
                      "RESCHEDULE_ACTION_CANCEL": 1,
                      "RESCHEDULE_ACTION_RESCHEDULE": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.items?.nested?.drafts?.nested?.enums?.nested?.DraftStatus && !$root.nested?.squareup?.nested?.items?.nested?.drafts?.nested?.enums?.nested?.UpdateDraftMode && !$root.nested?.squareup?.nested?.items?.nested?.drafts?.nested?.enums?.nested?.DraftOperation && !$root.nested?.squareup?.nested?.items?.nested?.drafts?.nested?.enums?.nested?.DraftType && !$root.nested?.squareup?.nested?.items?.nested?.drafts?.nested?.enums?.nested?.RescheduleAction) {
  $root.addJSON(jsonData);
}

/**
 * DraftStatus represents the lifecycle of a catalog draft.
 *
 * Transitions:
 *   PENDING    → PUBLISHING, SCHEDULED, UPDATING, ABANDONED
 *   SCHEDULED  → PUBLISHING, UPDATING, ABANDONED
 *   PUBLISHING → PUBLISHED, FAILED
 *   UPDATING   → PENDING, SCHEDULED, FAILED
 *   FAILED     → PUBLISHING, SCHEDULED, UPDATING, ABANDONED (retryable)
 *   PUBLISHED  → (terminal)
 *   ABANDONED  → (terminal)
 *
 * SOURCE DraftStatus @ squareup/items/drafts/enums/enums.proto at 26:1
 */
export const DraftStatus = $root.lookupEnum('squareup.items.drafts.enums.DraftStatus').values;
/**
 * UpdateDraftMode specifies how objects are merged during an UpdateDraftAsync operation.
 *
 * SOURCE UpdateDraftMode @ squareup/items/drafts/enums/enums.proto at 53:1
 */
export const UpdateDraftMode = $root.lookupEnum('squareup.items.drafts.enums.UpdateDraftMode').values;
/**
 * DraftOperation indicates the type of change applied to an object in a draft.
 *
 * SOURCE DraftOperation @ squareup/items/drafts/enums/enums.proto at 66:1
 */
export const DraftOperation = $root.lookupEnum('squareup.items.drafts.enums.DraftOperation').values;
/**
 * DraftType is a client-supplied label that categorizes the kind of change a draft represents.
 * The server does not validate that the draft's objects match the declared type. Clients use
 * this purely for grouping and display purposes (e.g. showing drafts in separate UI tabs).
 * Defaults to DRAFT_TYPE_GENERAL when not specified.
 *
 * SOURCE DraftType @ squareup/items/drafts/enums/enums.proto at 76:1
 */
export const DraftType = $root.lookupEnum('squareup.items.drafts.enums.DraftType').values;
/**
 * RescheduleAction indicates the action to perform on a scheduled draft.
 *
 * SOURCE RescheduleAction @ squareup/items/drafts/enums/enums.proto at 90:1
 */
export const RescheduleAction = $root.lookupEnum('squareup.items.drafts.enums.RescheduleAction').values;